<template>
  <div>
    <FriendNotificationV2 :msisdn.sync="friendMsisdn" :process-name="'friendNotification'" ref="friendNotificationComponent">
      <template v-for="slot in possibleChildSlotsFor('Friend')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </FriendNotificationV2>

    <div class="btn-wrapper">
      <button :disabled="disabledNext" @click="next()" class="button button--primary">Absenden</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'

export default {
  mixins: [preFilledInput('friendMsisdn', 'storedFriendMsisdn'), slotProxy(), transaction('friendNotification')],
  computed: {
    ...mapGetters('friendNotification', {
      storedFriendMsisdn: 'existingCustomerMsisdn'
    }),
    disabledNext() {
      return this.friendMsisdn.trim() === ''
    }
  },
  methods: {
    ...mapActions('friendNotification', ['referFriendSelfCare']),
    next() {
      this.referFriendSelfCare({ newCustomerMsisdn: this.friendMsisdn }).then(response => {
        if (response?.success) {
          this.friendMsisdn = ''
        }
        this.$refs.friendNotificationComponent.reloadCaptchaComponent()
      })
    },
    updateCaptchaCode(captchaData) {
      this.captchaInput = captchaData.code
    }
  }
}
</script>
